module.exports = __webpack_public_path__ + "static/pad-img-312cab7f3ad7243edae2b0dbb0012a2d.png";